import qs from 'qs'
import axios from 'axios'

axios.defaults.timeout = 5000 // 超时默认5s
// axios.defaults.baseURL = 'http://122.51.244.94:8080/' // 填写域名 线上
axios.defaults.baseURL = 'http://192.168.0.9:8080/' // 填写域名 本地

// http request 拦截器
axios.interceptors.request.use(
  config => {
    config.data = qs.stringify(config.data)
    config.headers = {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器即异常处理
axios.interceptors.response.use(response => {
  return response
}, error => {
  if (error && error.response) {
    switch (error.response.status) {
      case 400:
        // console.log('错误请求')
        break
      case 401:
        // console.log('未授权，请重新登录')
        break
      case 403:
        // console.log('拒绝访问')
        break
      case 404:
        // console.log('请求错误,未找到该资源')
        break
      case 405:
        // console.log('请求方法未允许')
        break
      case 408:
        // console.log('请求超时')
        break
      case 500:
        // console.log('服务器端出错')
        break
      case 501:
        // console.log('网络未实现')
        break
      case 502:
        // console.log('网络错误')
        break
      case 503:
        // console.log('服务不可用')
        break
      case 504:
        // console.log('网络超时')
        break
      case 505:
        // console.log('http版本不支持该请求')
        break
      default:
        // console.log(`连接错误${error.response.status}`)
    }
  } else {
    // console.log('连接到服务器失败')
  }
  return Promise.resolve(error.response)
})

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function fetch(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
        params: params
      })
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data)
      .then(response => {
        resolve(response.data)
      }, error => {
        reject(error)
      })
  })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data)
      .then(response => {
        resolve(response.data)
      }, error => {
        reject(error)
      })
  })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data)
      .then(response => {
        resolve(response.data)
      }, error => {
        reject(error)
      })
  })
}

/**
 * 下面是获取数据的接口
 */
/**
 * 测试接口
 * 名称：websitecount
 * 参数：paramObj/null
 * 方式：fetch/post/patch/put
 */
export const server = {
  // 获取统计数据量
  websitecount: function (paramObj) {
    return post('jiangxiligong/feedback/websitecount.htm', paramObj)
  },
  // 注册
  register: function (paramObj) {
    return post('jiangxiligong/userLogin/register.htm', paramObj)
  },
  // 登录
  login: function (paramObj) {
    return post('jiangxiligong/userLogin/login.htm', paramObj)
  },
  // 提交回答
  sendtestxlab: function (paramObj) {
    return post('jiangxiligong/xlabcontroller/sendtestxlab.htm', paramObj)
  },
  // 调用http://jiangxi.ilab-x.com的token
  getstatefromxlab: function (paramObj) {
    return post('jiangxiligong/xlabcontroller/getstatefromxlab.htm', paramObj)
  },
  // 告诉实验室是否有人开始做实验
  starttestxlab: function (paramObj) {
    return post('jiangxiligong/xlabcontroller/starttestxlab.htm', paramObj)
  }
}
